import { useState } from 'react';
import { DataSVG, DownloadSVG } from '../../components/svgs';
import { NAVIGATION_LINK_CONSTANTS, REPORT_CONSTANTS } from '../../constants/common';
import TransactionHistoryReportModal from './ReportDownloadModal';
import './reports.scss';

const Reports = (): JSX.Element => {
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);

  return (
    <div className="reports-page">
      <div className="reports card">
        <div className="reports__header">
          <h2>{NAVIGATION_LINK_CONSTANTS.REPORTS}</h2>

          <ul className="reports__tabs">
            <li className="active">
              <div className="transaction-history-tab">{NAVIGATION_LINK_CONSTANTS.TRANSACTION_HISTORY}</div>
            </li>
          </ul>
        </div>

        <div className="reports__body">
          <div className="reports__cards">
            <div className="transaction-history-report-card">
              <div className="transaction-history-report-card__icon">
                <div className="report-file-icon">
                  <DataSVG />
                </div>
                <div className="report-download-icon">
                  <DownloadSVG />
                </div>
              </div>

              <div className="transaction-history-report-card__content">
                <h3>{REPORT_CONSTANTS.TRANSACTION_HISTORY_REPORT}</h3>
                <p>{REPORT_CONSTANTS.DETAILS}</p>

                <button
                  type="button"
                  className="button large green generate-report-button"
                  onClick={() => setIsReportModalOpen(true)}>
                  <DownloadSVG />
                  {REPORT_CONSTANTS.GENERATE_REPORT}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TransactionHistoryReportModal isOpen={isReportModalOpen} onClose={() => setIsReportModalOpen(false)} />
    </div>
  );
};

export default Reports;
